import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-seller-product-activation-card',
  templateUrl: './seller-product-activation-card.component.html',
  styleUrls: ['./seller-product-activation-card.component.scss'],
})
export class SellerProductActivationCardComponent {
  
  @Input() totalProductsAssigned: number | null = 0;
  @Input() totalProductsActivated: number | null = 0;
  @Input() activationRatePercentage: number | null = 0;

  constructor() {}

  getRateColor(): string {
    const rate = this.activationRatePercentage || 0; 

    if (rate >= 75) {
      return 'high-rate';
    } else if (rate >= 50) {
      return 'medium-rate';
    } else {
      return 'low-rate';
    }
  }


  get formattedRate(): string {
    const rate = this.activationRatePercentage || 0;
    
    return rate.toFixed(2);
  }
}